import { Button } from 'primereact/button';
import { memo } from 'react';
import { Citation } from '../types';

type CitationButtonsProps = {
  citations: Citation[];
  onCitationClick: (citation: Citation) => void;
};

export const CitationButtons = memo(
  ({ citations, onCitationClick }: CitationButtonsProps) => (
    <div className="message-citations mb-2">
      {citations.map((citation, index) => (
        <Button
          key={index}
          label={`Citation ${index + 1}`}
          size="small"
          style={{
            backgroundColor: 'var(--bq-color-info, #3B82F6)',
            borderColor: 'var(--bq-color-info, #3B82F6)',
            color: 'var(--bq-button-text, #ffffff)',
          }}
          onClick={() => onCitationClick(citation)}
        />
      ))}
    </div>
  ),
);
